export const accessibility_searchmap = {
  title: "guests.salonSearchMap.accessibility",
  allowMultiple: true,
  isFilterActive: false,
  type: "dropdown",
  options: [
    {
      id: 0,
      title: "guests.salonSearchMap.elevator",
      selected: false,
      key: "accessibility_searchmap",
      value: "Elevator",
    },
    {
      id: 1,
      title: "guests.salonSearchMap.wheelchair",
      selected: false,
      key: "accessibility_searchmap",
      value: "Wheelchair accessibility",
    },
    {
      id: 2,
      title: "guests.salonSearchMap.floor0",
      selected: false,
      key: "accessibility_searchmap",
      value: "Floor zero",
    },
  ],
};

export const date = {
  title: "guests.salonSearchMap.availabilityDate",
  allowMultiple: false,
  isFilterActive: false,
  type: "date",
  key: "date",
  options: [],
};

export const time = {
  title: "guests.salonSearchMap.hourOfTheDay",
  allowMultiple: true,
  isFilterActive: false,
  type: "dropdown",
  options: [
    {
      id: 0,
      title: "guests.salonSearchMap.morning",
      selected: false,
      key: "time",
      value: "morning",
    },
    {
      id: 1,
      title: "guests.salonSearchMap.afternoon",
      selected: false,
      key: "time",
      value: "noon",
    },
    {
      id: 2,
      title: "guests.salonSearchMap.evening",
      selected: false,
      key: "time",
      value: "evening",
    },
  ],
};

export const available_places = {
  title: "guests.salonSearchMap.guestsNumber",
  allowMultiple: false,
  isFilterActive: false,
  type: "dropdown",
  options: [
    {
      id: 0,
      title: "guests.salonSearchMap.oneGuest",
      selected: false,
      key: "available_places",
      value: "1",
    },
    {
      id: 1,
      title: "guests.salonSearchMap.twoGuests",
      selected: false,
      key: "available_places",
      value: "2",
    },
    {
      id: 2,
      title: "guests.salonSearchMap.threeGuests",
      selected: false,
      key: "available_places",
      value: "3",
    },
  ],
};

export const is_digital = {
  title: "host.onlyDigitalSalons",
  allowMultiple: true,
  isFilterActive: false,
  type: "dropdown",
  options: [
    {
      id: 0,
      title: "host.digitalSalon",
      selected: false,
      key: "is_digital",
      value: true,
    },
    {
      id: 1,
      title: "host.physicalSalon",
      selected: false,
      key: "is_digital",
      value: false,
    },
  ],
};
